'use client'

import { trackClick } from '@/lib/mixpanel'
import Link from 'next/link'

export default function TrackedLink(props) {
  return (
    <Link {...props} onClick={(e) => trackClick(e, props.trackingdata)}>
      {props.children}
    </Link>
  )
}
